import Handlebars from 'handlebars';
import { HandlebarsComparator } from './types';

Handlebars.registerHelper(
    'IfTernary',
    function <TTrue, TFalse>(
        // `v1` and `v2` come from the template and can be anything
        /* eslint-disable @typescript-eslint/no-explicit-any */
        v1: any,
        op: HandlebarsComparator,
        v2: any,
        /* eslint-enable @typescript-eslint/no-explicit-any */
        trueValue: TTrue,
        falseValue: TFalse
    ): TTrue | TFalse | null {
        switch (op) {
            case '==':
                return v1 == v2 ? trueValue : falseValue;
            case '!=':
                return v1 != v2 ? trueValue : falseValue;
            case '===':
                return v1 === v2 ? trueValue : falseValue;
            case '<':
                return v1 < v2 ? trueValue : falseValue;
            case '<=':
                return v1 <= v2 ? trueValue : falseValue;
            case '>':
                return v1 > v2 ? trueValue : falseValue;
            case '>=':
                return v1 >= v2 ? trueValue : falseValue;
            case '&&':
                return v1 && v2 ? trueValue : falseValue;
            case '||':
                return v1 || v2 ? trueValue : falseValue;
            default:
                return null;
        }
    }
);
